import type { Theme } from '@mui/material/styles';
import { useSidebar } from '@src/app/layout';
import { useMainContext } from './MainContext';
import { Box } from '@src/shared/ui/layout';
import { Outlet } from '@tanstack/react-router';
import { HeaderProvider } from './Header';

const StyleSheet = {
  main: ({ scrollable }: { scrollable: boolean }) => ({
    backgroundColor: 'grey.150',
    flexGrow: 1,
    height: '100%',
    minWidth: 0,
    overflowX: scrollable ? 'auto' : 'visible',
    position: 'relative',
  }),
  content: ({ isCollapsed, scrollable }: { isCollapsed: boolean; scrollable: boolean }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '25px 20px 25px 10px',
    minWidth: scrollable ? (t: Theme) =>
      `calc(1024px - ${isCollapsed ? t.layout.sidebar.minWidth : t.layout.sidebar.maxWidth}px)`
      : 'auto',
    width: '100%',
  }),
};

export default function Main() {
  const sidebar = useSidebar();
  const { scrollable } = useMainContext();

  if (!sidebar) {
    return null;
  }
  const { isCollapsed } = sidebar;
  return (
    <Box sx={StyleSheet.main({ scrollable })} component="main">
      <Box sx={StyleSheet.content({ isCollapsed, scrollable })}>
        <HeaderProvider>
          <Outlet />
        </HeaderProvider>
      </Box>
    </Box>
  );
}
